import axios from 'axios';
import store from '@/store';

// @TODO might not need that, maybe to take locale from localstorage so it doesn't take dependency
import i18n from '@speechki-frontend/core/i18n/i18n';
import { setHttp } from '@speechki-frontend/shared/axios/httpRef';

import { makeid } from '@speechki-frontend/shared/helpers/functions';

const baseURL = process.env.VUE_APP_BASE_URL;

const _axios = axios.create({
    baseURL,
});

const LOCALES_MAP = {
    rus: 'ru',
    eng: 'en',
};

_axios.defaults.headers.common['Accept-Language'] = LOCALES_MAP[i18n.global.locale];

_axios.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers['Authorization'] = 'JWT ' + token;
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

_axios.interceptors.response.use(
    function (response) {
        console.log(response.config.url, response.data);
        return response.data;
    },
    function (error) {
        if (error.response) {
            if (error.response.status === 401) {
                store.commit('CLEAR_USER_DATA');
                return;
            }

            if (error.response.status >= 500) {
                store.dispatch('pushToast', {
                    id: makeid(),
                    type: 'error',
                    title: `${error.response.status} ${error.response.statusText}`,
                    text: 'Repeat the action again, or reload the page.',
                });
                return;
            }
            if (error.response.data) {
                return Promise.reject({ ...error.response.data, status: error.response.status });
            }
            return Promise.reject(error.response);
        } else {
            window.location.href = '/unavailable';
        }
    }
);

const Plugin = {
    install(app) {
        app.config.globalProperties.$http = _axios;
        setHttp(_axios);
    },
};

export { _axios as ApiClient };

export default Plugin;
